import React from "react";
import { Link } from "react-router-dom";

  const sendmail = () => {
    var link =
      "mailto:info@myprega.com" +
      "?cc=" +
      "&subject= About subscription" +
      "&body=" +
      encodeURIComponent("\n");
    window.location.href = link;
  };

function Footer() {
  return (
    <>
      <div className="container-fluid myfooter">
        <div className="container">
          {/* Row 1 */}
          <div className="row mb-4">
            <div className="col-12 col-md-4 mb-3">
              <Link to="/home">
                <img src="/logo.png" id="logo" style={{ maxWidth: "150px" }} />
              </Link>
            </div>
        
            <div className="col-6 col-md-4 mb-3">
              <p className="fw-bold mb-1" style={{ color: "#000" }}>Packages</p>
              <Link to="/elemental-care" className="text-dark d-block">Elemental Care</Link>
              <Link to="/cherish-care" className="text-dark d-block">Cherish care</Link>
              <Link to="/PregaStart-Early-Pregnancy-Package" className="text-dark d-block">Early Pregnancy Package</Link>
            </div>
        
            <div className="col-6 col-md-4 mb-3">
              <Link to="/about" className="fw-bold text-dark d-block mb-1">About Us</Link>
              <Link to="/contact" className="fw-bold text-dark d-block mb-1">Contact Us</Link>
              <Link to="/blogs" className="fw-bold text-dark d-block">Pregnancy Blogs</Link>
            </div>
          </div>
        
          {/* Row 2 */}
          <div className="row align-items-start">
            <div className="col-12 col-md-4 mb-3">
              <p className="fw-bold mb-2" style={{ color: "#000" }}>Connect with us</p>
              <div className="d-flex gap-3">
                <Link to="https://www.facebook.com/myprega" target="_blank">
                  <img src="/facebook.png" className="img-fluid icondiv" style={{ width: "24px" }} />
                </Link>
                <Link to="https://www.instagram.com/myprega" target="_blank">
                  <img src="/instagram.png" className="img-fluid icondiv" style={{ width: "24px" }} />
                </Link>
                <Link to="https://www.linkedin.com/company/myprega" target="_blank">
                  <img src="/linkedin.png" className="img-fluid icondiv" style={{ width: "24px" }} />
                </Link>
                <Link to="https://twitter.com/myprega" target="_blank">
                  <img src="/twitter.png" className="img-fluid icondiv" style={{ width: "24px" }} />
                </Link>
              </div>
            </div>
        
            <div className="col-6 col-md-4 mb-3">
              <p className="fw-bold mb-2" style={{ color: "#000" }}>Policy</p>
              <Link to="/terms-of-use" className="text-dark d-block">Terms of use</Link>
              <Link to="/refund-&-cancellation-policy" className="text-dark d-block">Refunds & cancellation policy</Link>
              <Link to="/disclaimer-policy" className="text-dark d-block">Disclaimer Policy</Link>
            </div>
        
            <div className="col-6 col-md-4 mb-3">
              <p className="fw-bold mb-1" style={{ color: "#000" }}>
                Are you someone, not a mom-to-be?
                <br />
                <span style={{ color: "#f06292" }}>Be mom buddy!</span><br />
                Join Our Community!
              </p>
              <Link
                style={{
                  cursor: "pointer",
                  color: "white",
                  backgroundColor: "#2196f3",
                  padding: "8px 20px",
                  borderRadius: "6px",
                  display: "inline-block",
                  textDecoration: "none",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                onClick={sendmail}
              >
                SUBSCRIBE
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
